import { FamilyTree } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: `${routesMap.FAMILY_TREE.path}/:id`,
      name: "Theme01",
      key: `${routesMap.FAMILY_TREE.path}/:id`,
      commonRoute: false,
      private: false,
      withAuth: false,
      element: <FamilyTree />,
    },
  ];
}
